var ww = window.innerWidth || document.documentElement.clientWidth;
var wh = window.innerHeight || document.documentElement.clientHeight;

$(window).on('resize', function () {
    ww = window.innerWidth || document.documentElement.clientWidth;
    wh = window.innerHeight || document.documentElement.clientHeight;
});

//Маска для полей с телефоном.
var phoneMaskOptions = {
    mask: '+7(000)000-00-00', 
    lazy: false
};
function setPhoneMask(elems){
    if(!elems) return;
    $(elems).each(function(){
        IMask(this, phoneMaskOptions);
    });
}
$(function(){
    setPhoneMask('.claim_phone');
});

function incube_ajax(block, data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block=' + block + '&action=' + action + '&data_type=' + data_type,
        data: params,
        dataType: data_type,
        success: success_func,
        error: error_func
    });
}

function incube_file_ajax(block, data_type, action, params, success_func, error_func) {
    $.ajax({
        type: "POST",
        url: '/ajax.php?block=' + block + '&action=' + action + '&data_type=' + data_type,
        data: params,
        dataType: data_type,
        processData: false,
        contentType: false,
        success: success_func,
        error: error_func
    });
}

//Функция для работы с метрикой.
var _METRIKA_NUM_ = 41475844;
function some_metrika(){
    if(typeof window.ym==='function'){
        ym.apply(null, arguments);
    }else{
        console.log('metrika', arguments);
    }
}

//Обработчик для вызова всплывающей формы.
//Пример: <a href="/" class="show_form" cid="1">Заказать звонок</a>
//cid - это id заявки
$(document).on('click', '.show_form', function (e) {
    e.preventDefault();
    e.stopPropagation();
    var cid = $(this).attr('cid');
    var block = $('#' + $(".ajax_claim[data-cid='" + cid + "']").attr('id'));
    claim_form_open(block);
});

$(document).on('submit', ".ajax_form", function (e) {
    e.preventDefault();
    var button = $(this).find(".submit-button");
    if (button.length > 0){
        if ($('button').prop("disabled")){
            return false;
        }
        $('button').prop('disabled', true);
    }
    incube_file_ajax('claim', 'json', 'send_form', new FormData(this), claimform);
});

$(document).on('change', '.is-invalid', function () {
    $(this).removeClass('is-invalid');
});

function clear_claim_block(claim_block_selector) {
    var claim_block = $(claim_block_selector);
    var label_inputs = 0;
    if (claim_block.hasClass('label_inputs'))
        label_inputs = 1;

    claim_block.find('.claim_input,.claim_textarea').val('');
    if (label_inputs)
        claim_block.find('.claim-label').removeClass('is-invalid');
    else
        claim_block.find('.claim_input').removeClass('is-invalid');
}

function claim_form_open(claim_block_selector) {
    var claim_block = $(claim_block_selector);

    clear_claim_block(claim_block);
    claim_block.find('.cf_ok').hide();
    claim_block.find('.form_content').show();
    claim_block.find('.cf_error').hide();
    setPhoneMask(claim_block.find('input.claim_phone'));

    $.fancybox.open({
        src: claim_block,
        type: 'inline',
        /*opts: {
            smallBtn: false, 
            buttons: ['close']
        }*/
    });
}

function claimform(data) {
    var current_claim = $('#ajax_claim_' + data.pid);
    var label_inputs = 0;
    if (current_claim.hasClass('label_inputs'))
        label_inputs = 1;

    var button = $(current_claim).find(".submit-button");
    if (button.length > 0){
        $('button').prop('disabled', false);
    }

    current_claim.find('.cf_error').hide();
    current_claim.find('.cf_ok').hide();
    var popup_messages = current_claim.data('popup-messages');

    var current_form = current_claim.find('form');
    var new_rand = getRandomInt(1000000, 10000000);

    current_form[0].rand.value = new_rand;
    if (current_form[0].captcha) {
        current_form[0].captcha.value = '';
        current_form.find('.captcha_image').attr('src', '/captcha.php?rand=' + new_rand);
    }
    if (data.flag == 'ok') {

        if (popup_messages) {
            clear_claim_block(current_claim);
            $.fancybox.open({
                src: "<div><div class='cf_ok' style='display: block;'><span>Спасибо!</span><div class='suc_text'>" + data.claim.descr + "</div></div></div>",
                type: 'inline'
            });
        } else {
            current_claim.find('.suc_text').empty();
            current_claim.find('.suc_text').html(data.claim.descr);
            current_claim.find('.cf_ok').show();
            current_claim.find('.form_content').hide();
        }
        //Остались вопросы
        if (data.claim.id == 2) {
            some_metrika(_METRIKA_NUM_, 'reachGoal', 'request');
        }
        //Предложение прямо сейчас
        if (data.claim.id == 3) {
            some_metrika(_METRIKA_NUM_, 'reachGoal', 'phone');
        }
    } else {
        current_claim.find('.err_text').empty();
        if (label_inputs)
            current_claim.find('.captcha-label').removeClass('is-invalid');
        else
            current_claim.find('.captcha_input').removeClass('is-invalid');

        if (data.error[0]) {
            if (label_inputs)
                current_claim.find('.claim-label').removeClass('is-invalid');
            else
                current_claim.find('.claim_input').removeClass('is-invalid');

            for (var key in data.error_fields) {
                if (label_inputs)
                    $('.claim_input[name="id' + key + '"]').parents('.claim-label').addClass('is-invalid');
                else
                    $('.claim_input[name="id' + key + '"]').addClass('is-invalid');
            }
            var error_s = '';
            for (var key in data.error) {
                error_s += '<div>' + data.error[key] + '</div>';
            }

            if (popup_messages) {
                $.fancybox.open({
                    src: "<div style='font-size: 20px; color: red;'>" + error_s + "</div>",
                    type: 'inline'
                });
            } else {
                current_claim.find('.err_text').html(error_s);
                current_claim.find('.cf_error').show();
            }
        }
        if (data.error_captcha) {
            if (label_inputs)
                current_claim.find('.captcha-label').addClass('is-invalid');
            else
                current_claim.find('.captcha_input').addClass('is-invalid');
        }

    }
}

function reload_captcha(pid) {
    var rand = Math.random();
    $('#rand-' + pid).val(rand);
    $('#captcha-' + pid).attr('src', '/captcha.php?rand=' + rand);
}

//Случайное целое.
function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min)) + min;
}

//Получить блок с заявкой с сервера.
var popup_claims = {};

function get_popup_claim_block(claim_id, in_stucture_id) {
    if (popup_claims[claim_id]) {
        //popup_claims[claim_id].addClass('active');
        claim_form_open(popup_claims[claim_id]);
    } else {
        incube_ajax('claim', 'html', 'get_popup_claim_block', {
            'in_structure_id': in_stucture_id,
            'claim_id': claim_id,
            'from_page': window.location.href
        }, function (html) {
            popup_claims[claim_id] = $(html).appendTo('body');
            setPhoneMask(popup_claims[claim_id].find('.claim_phone'));
            claim_form_open(popup_claims[claim_id]);
        });
    }
}

//Кнопка закрытия всплывающей заявки.
$(document).on('click', '.popup-close', function () {
    $(this).parents('.popup').removeClass('active');
});



//Функции для работы с cookie.
//Получить значений cookie.
function getCookie(name, json) {
    if (!name) {
        return undefined;
    }

    json = json || false;

    var matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + "=([^;]*)"
    ));

    if (matches) {
        var res = decodeURIComponent(matches[1]);
        if (json) {
            try {
                return JSON.parse(res);
            }
            catch(e) {}
        }
        return res;
    }

    return undefined;
}
//Установить значения cookie.
function setCookie(name, value, options) {
    if (!name) {
        return;
    }

    options = options || {path: '/'};

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    if (value instanceof Object) {
        value = JSON.stringify(value);
    }

    var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (var optionKey in options) {
        updatedCookie += "; " + optionKey;

        var optionValue = options[optionKey];

        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }

    document.cookie = updatedCookie;
}
//Удалить cookie.
function deleteCookie(name) {
    setCookie(name, null, {
        expires: new Date(),
        path: '/'
    });
}